<template>
  <div id="attendance-agenda">
    <Breadcrumbs
      :breadcrumbs="[
      { title: this.$t('menu.configurations'), disabled: true },
      { title: this.$t('menu.attendances'), disabled: true}
    ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <va-popover
          v-if="hasPermissionsToDownloadAll"
          class="mr-3"
          placement="left"
          :message="$t('clinical.buttons.download_hearing_test')"
        >
          <i class="fa fa-file-zip-o custom-i-btn" style="width: 20px" @click.prevent="downloadPdf(true)"></i>

        </va-popover>

        <va-popover
          class="mr-3"
          placement="left"
          :message="$t('clinical.buttons.download_hearing_test')"
        >
          <span class="icon i-cloud-download" @click.prevent="downloadPdf">
          </span>
        </va-popover>


      </div>

    </Breadcrumbs>
    <div class="calendar-wrapper">
      <div v-if="isLoading" class="loading-overlay">
        <LoadingPlaceholder />
      </div>

      <FullCalendar
        id="attendanceAgenda"
        ref="attendanceAgenda"
        :key="calendarKey"
        :options="calendarOptions">
        <template v-slot:eventContent='data'>
          <Event
            :view="data.view"
            :event="data.event"
          />
        </template>

      </FullCalendar>
    </div>
    <RegisterAttendanceModal
      v-if="showRegistAttendanceModal"
      v-bind="propsRegistAttendanceModal"
      @attendanceCreated="attendanceCreated"
      @cancel="modalClosed" />
  </div>
</template>
<script>
import Breadcrumbs from "@/components/common/Breadcrumbs.vue";
import FullCalendar from "@fullcalendar/vue";
import Loading from "@/components/common/loaders/Loading.vue";
import Event from "@/components/attendances/Event";
import moment from "moment/moment";
import dayGridPlugin from "@fullcalendar/daygrid";
import momentPlugin from "@fullcalendar/moment";
import interactionPlugin from "@fullcalendar/interaction";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder.vue";
import { AttendandeAndVacationsService } from "@/api/AuthService";
import RegisterAttendanceModal from "@/components/attendances/RegisterAttendanceModal.vue";


export default {
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  components: { RegisterAttendanceModal, LoadingPlaceholder, Loading, Breadcrumbs, Event, FullCalendar },
  data () {
    return {
      isLoading: false,
      showRegistAttendanceModal: false,
      propsRegistAttendanceModal : {
        isForToday: false
      },
      calendarKey: 0,
      calendarAPI: null,
      cancellationEventsCallback: null,
      events: [],
      calendarOptions: {
        eventSources: [
          {
            events: (options, callback) => {
              let params = {
                start: moment(options.start).format('YYYY-MM-DD HH:mm:ss'),
                end: moment(options.end).format('YYYY-MM-DD HH:mm:ss')
              }
              this.isLoading = true

              AttendandeAndVacationsService.getAttendances(params)
                .then(response => {
                  this.events = response.map(event => {
                    let obj = {
                      ...event,
                    }
                    if (event.type.type !== 'holiday') {
                      obj.start = this.$options.filters.localTime(event.start)
                      obj.end = this.$options.filters.localTime(event.end)
                    } else {
                      obj.date = moment(event.date).format('YYYY-MM-DD')
                    }

                    return obj
                  })

                  callback(this.events.map(event => {
                    let color = '#29c4a9'

                    if(event.type && event.type.type === 'holiday') {
                      color = '#939393'
                    } else if (event.type && event.type.color) {
                      color = event.type.color
                    }

                    return {
                        ...event,
                        display: event.type.type === 'holiday' ? 'background' : 'block',
                        color: color
                      }
                  }))

                  //check if has already filled info for today
                  if(moment(this.calendarAPI.getDate()).get('month') === moment().month()) {
                    let todayEvent = this.events.find(event => {
                      return event.type.type !== 'holiday' && moment().isSame(event.start, 'day')
                    })
                    if (!todayEvent && moment().isoWeekday() !== 6 && moment().isoWeekday() !== 7) {
                      this.propsRegistAttendanceModal.isForToday = true
                      this.showRegistAttendanceModal = true
                    }
                  }
                })
                .catch(errors=> {
                  console.error(errors)
                })
                .finally(() => {
                  this.isLoading = false
                })
            }
          }
        ],
        lazyFetching: false,
        eventColor: '#29c4a9',
        plugins: [dayGridPlugin, momentPlugin, interactionPlugin],
        headerToolbar: {
          left: 'title',
          right: 'prev next'
        },
        eventDisplay: 'block',
        buttonText: {
          today: this.$t('agenda.buttons.today'),
          month: this.$t('agenda.buttons.month'),
          week: this.$t('agenda.buttons.week'),
          day: this.$t('agenda.buttons.day'),
          listMonth: this.$t('agenda.buttons.listMonth'),
        },
        initialView:  'dayGridMonth',
        locale: this.selectedLanguage,
        firstDay: 1,
        hiddenDays: [0, 6],
        allDayContent: this.$t('agenda.buttons.all-day'),
        allDayClassNames: 'calendar__allday__label',
        titleFormat: 'MMMM, YYYY',
        displayEventEnd: true,
        displayEventTime: false,
        nowIndicator: true,
        height: 'auto',
        slotMinTime: '07:00:00',
        slotMaxTime: '20:00:00',
        dayHeaderFormat: 'ddd',
        eventTimeFormat: 'HH:mm',
        editable: false,
        weekends: true,
        allDaySlot: true,
        allDayDefault: true,
        selectable: true,
        selectMirror: true,
        unselectAuto: true,
        navLinks: false,
        disableResizing: false,
        eventClick: this.eventSelected,
        eventDrop: this.updateEventFromUI,
        // eventResize: this.updateEventFromUI,
        dateClick: null,
        select: this.eventCreated,
        navLinkDayClick: this.dayClicked,
        datesSet: this.datesDidUpdate,
      },
    }
  },
  mounted: function () {
    this.calendarAPI = this.$refs.attendanceAgenda.getApi()
    if (this.calendarAPI) {
      this.calendarAPI.setOption('locale', this.selectedLanguage)
    }
  },
  methods: {
    modalClosed: function () {
      this.showRegistAttendanceModal = false
      this.propsRegistAttendanceModal = {
        isForToday: false
      }
    },
    attendanceCreated: function () {
      this.showRegistAttendanceModal = false
      this.propsRegistAttendanceModal = {
        isForToday: false
      }
      this.loadEvents()
    },
    loadEvents: function () {
      this.calendarAPI.refetchEvents()
    },
    eventSelected: function ({event}) {
      this.propsRegistAttendanceModal = {
        isForToday: false,
        event: {
          id: event.id,
          ...event.extendedProps,
          start: moment(event.start),
          end: moment(event.end)
        }
      }

      this.showRegistAttendanceModal = true
    },
    eventCreated: function (event) {
      if(moment(event.start).isAfter(moment(), 'day')) {
        this.calendarAPI.unselect()
        console.log("Cannot do anything for future dates")
        return
      }
      const eventForDay = this.events.find(elem => moment(elem.start).isSame(event.start, 'day'))
      //if there is an event in the day, use it and it is an update, otherwise its a new one
      if(eventForDay) {
        this.propsRegistAttendanceModal = {
          isForToday: false,
          event: {
            id: eventForDay.id,
            ...eventForDay,
            start: moment(eventForDay.start),
            end: moment(eventForDay.end)
          }
        }
      } else {
        this.propsRegistAttendanceModal = {
          isForToday: false,
          date: moment(event.start).format('YYYY-MM-DD'),
        }
      }

      this.showRegistAttendanceModal = true
    },
    downloadPdf: function(allUsers = false) {
      const date = moment(this.calendarAPI.currentData.currentDate)
      AttendandeAndVacationsService.downloadPdf(date.format('YYYY-MM-DD'), allUsers)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `assiduidade_${date.month()+1}_${date.year()}.zip`)
          document.body.appendChild(link)
          link.click()
        }).catch(err => {
          console.log(err)
          this.showToast(this.$t('clinical.people.update.errors.something_went_wrong'), this.$store.state.errorToastOptions)
      })
    }

  },
  computed: {
    selectedLanguage: function () {
      return this.$i18n.locale()
    },

    hasPermissionsToDownloadAll: function () {
      const perms = this.component.service.user_permissions.find(elem => elem.info_type === 300)
      return perms && perms.access_type === 3
    }
  }
}
</script>
<style lang='scss'>
// you must include each plugins' css
// paths prefixed with ~ signify node_modules
// @import '~@fullcalendar/core/main.css';
// @import '~@fullcalendar/daygrid/main.css';
// @import '~@fullcalendar/timegrid/main.css';

@mixin for-desktop {
  @media (min-width: 599px) {
    @content;
  }
}

#attendance-agenda {
  .calendar-wrapper {
    position: relative;

    .vld-overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 500;

      .vld-background {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgb(245, 245, 245);
        opacity: 0.3;
      }

      .vld-icon {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .fc-header-toolbar {
    button {
      background-color: transparent;
      -webkit-box-shadow: 0 0 4px 0 rgba(98, 106, 119, 0.25);
      box-shadow: 0 0 4px 0 rgba(98, 106, 119, 0.25);
      border-radius: 25px;
      border: none;
      color: #d4d4d4;
      padding-top: 0.3em;
      padding-bottom: 0.3em;
      padding-left: 1em;
      padding-right: 1em;

      &:hover {
        color: #6e6e6e;
      }

      &:not(:first-child) {
        margin-left: 1em;
      }

      // &:disabled {
      //   color:#d4d4d4;
      // }
      &.fc-button-active {
        color: #6e6e6e;
        font-weight: 600;
      }

      &.fc-prev-button {
        margin-left: 1.5em;
      }

      &.fc-next-button,
      &.fc-prev-button {
        padding: 0.3em;
        color: #6e6e6e;

        span {
          font-weight: bold;
          font-size: 1.3em;
        }
      }
    }

    .fc-toolbar-title {
      color: #414141;
      font-weight: 600;
      font-size: 1.5em;
    }
  }

  /*.fc-daygrid-event, .fc-timegrid-event {
    background-color: #e8e8e8 !important;
    border-left-width: 10px;
    border-right-width: 0px;
    border-top-width: 0px;
    border-bottom-width: 0px;
    border-radius: 0%;

    .fc-event-main {
      color: #6E6E6E !important;
      padding-left: 5px;
      overflow: hidden;
    }
  }*/
  .fc-daygrid-event, .fc-timegrid-event .fc-event-main {
    color: #a4a4a4 !important;
    padding-left: 5px;
    overflow: hidden;
  }
  .fc-daygrid-event-harness {
    a{
      min-height: 43px;
    }
  }

  .fc .fc-bg-event{
    opacity: 1 !important;
    color: white;
  }

  .person-name {
    color: #414141 !important;
    font-weight: 600;
  }

  .fc-timegrid-slot-label {
    color: #414141;
  }

  td.fc-timegrid-slot {
    border: 0.5px solid #d3d3d3 !important;
  }

  .fc-timegrid-cols td,
  .fc-timegrid-slot.fc-timegrid-slot-label,
  .fc-theme-standard .fc-scrollgrid,
  .fc-direction-ltr .fc-timeGridWeek-view .fc-scrollgrid tr > *:first-child,
  .fc-direction-ltr .fc-timeGridDay-view .fc-scrollgrid tr > *:first-child {
    border: none !important;
  }

  .fc-timeGridWeek-view td.fc-timegrid-slot.fc-timegrid-slot-lane,
  .fc-timeGridDay-view td.fc-timegrid-slot.fc-timegrid-slot-lane {
    // border-top: solid !important;
    border-right: none !important;
    border-left: none !important;
  }

  .fc-timeGridWeek-view tr:first-of-type td.fc-timegrid-slot.fc-timegrid-slot-lane,
  .fc-timeGridDay-view tr:first-of-type td.fc-timegrid-slot.fc-timegrid-slot-lane {
    border-top: 0.5px solid #d3d3d3 !important;
  }

  .fc-scrollgrid-section.fc-scrollgrid-section-header.fc-scrollgrid-section-sticky > td {
    border: none;
  }

  .fc-dayGridMonth-view .fc-scrollgrid-section.fc-scrollgrid-section-body > td {
    border-left: 0.5px solid #d3d3d3 !important;
    border-right: 0.5px solid #d3d3d3 !important;
    border-bottom: 0.5px solid #d3d3d3 !important;
  }

  .fc-scrollgrid-section.fc-scrollgrid-section-header.fc-scrollgrid-section-sticky > td {
    border-bottom: 0.5px solid #d3d3d3 !important;
  }

  .fc-scrollgrid-section-sticky > td {
    background-color: transparent;
  }

  th.fc-day-today, td.fc-day-today {
    background-color: #ebebeb;
  }

  .fc-day-grid-event > .fc-content {
    white-space: normal;
    text-overflow: ellipsis;
    max-height: 20px;
  }

  .fc-day-grid-event > .fc-content:hover {
    max-height: none !important;
  }

  .calendar__allday__label {
    font-size: 0.9rem;
  }

  .fc-header-left, fc-header-center, fc-header-right {
    width: 100%;
    display: block;
  }

  .floating__button {
    position: fixed;
    z-index: 9999;
    color: #29c4a9;
    font-size: 2rem;
  }

  .fc-col-header-cell {
    color: #d3d3d3;

    &.fc-day-today {
      color: #6E6E6E;
    }
  }

  .calendar__header__label {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & .calendar__header__label__weekday {
      font-size: 0.6rem;
      text-transform: uppercase;
      @include for-desktop {
        font-size: 1.1rem;
      }
    }

    & .calendar__header__label__day {
      font-size: 0.8rem;
      font-weight: bold;
      @include for-desktop {
        font-size: 2.1rem;
      }

      &.view__dayGridMonth {
        display: none !important;
      }
    }
  }

  // .fc td, .fc th, .fc-timegrid, .fc-timeGridWeek-view, .fc-view {
  //   border-style: double !important;
  //   border-width: 0px !important;
  //   border-color: #aaa !important;
  // }

  .fc-col-header-cell {
    border-style: double !important;
    border-width: 0px !important;
    border-color: #aaa !important;
  }

  .fc-scrollgrid-section-header {
    border-left-style: double !important;
    border-left-width: 0px !important;
    border-left-color: #aaa !important;
  }

  .fc-timegrid-slot {
    height: 50px !important;
  }

  .fc-button-primary {
    color: #fff;
    background-color: #29c4a9;
    border-color: #29c4a9;
  }

  .fc-content {
    white-space: initial !important;
  }
}

#attendance-agenda {
  & span.fa.fa-upload {
    font-size: 1.5rem;
    margin-right: 5px;

    &:hover {
      cursor: pointer;
    }
  }
}
.background-striped {
  background: repeating-linear-gradient(45deg, #e8e8e8, #e8e8e8 10px, #d9d9d9 10px, #d9d9d9 20px)
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}

.custom-i-btn {
  font-size: 25px;
  padding-bottom: 8px;
  color: #414141;
}
</style>
